// Components==============
import { faVolumeUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { motion } from 'framer-motion';
import React, { useContext, useEffect, useState } from 'react';
import { ThermometerSequenceContext } from 'screens/Home/components/ThermometerSequence/ThermometerSequence';
import { useAudio } from 'utilities/useAudio';
import SpiekHappy from './SpiekHappy';
import SpiekOke from './SpiekOke';
import SpiekSad from './SpiekSad';
import './Thermometer.module.scss';
// =========================

const Svg = ({
    score,
    setScore,
}: {
    score: number;
    setScore: (number: number) => void;
}) => {
    const { isViewing } = useContext(ThermometerSequenceContext);

    const [emotion, setEmotion] = useState<'happy' | 'sad' | 'oke'>('sad');
    useEffect(() => {
        if (score >= 0 && score <= 3) setEmotion('sad');
        if (score >= 4 && score <= 6) setEmotion('oke');
        if (score >= 7 && score <= 10) setEmotion('happy');
    }, [score]);

    const getColor = () =>
        emotion === 'sad'
            ? '#f66b12'
            : emotion === 'oke'
            ? '#FCB922'
            : '#42C6B9';

    function handleButtonPress() {
        if (score < 10) return setScore(score + 1);
        setScore(1);
    }

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="140.405"
            height="553.599"
            viewBox="0 0 140.405 553.599"
            styleName={`svg ${isViewing ? 'viewing' : ''}`}
        >
            <defs>
                <clipPath id="clip-path">
                    <circle
                        id="Ellipse_245"
                        data-name="Ellipse 245"
                        cx="44.334"
                        cy="44.334"
                        r="44.334"
                        fill="none"
                    />
                </clipPath>
                <clipPath id="clip-path-2">
                    <path
                        id="Path_3361"
                        data-name="Path 3361"
                        d="M623.81,452.669c-3.728-6.325-1.427-17.333-12.1-21.416-10.808-4.132-23.1-4.7-25.8,5.878s3.32,22.819,9.937,26.608,23.993,9.626,29.577,10,10.249-4.4,11.347-8.354C637.744,461.859,627.538,458.994,623.81,452.669Z"
                        transform="translate(-585.243 -428.49)"
                        fill="#fff"
                    />
                </clipPath>
                <clipPath id="clip-path-3">
                    <path
                        id="Path_3378"
                        data-name="Path 3378"
                        d="M551.2,479.438a26.411,26.411,0,0,0-5.843.261h0a26,26,0,0,0-2.783.59c-6.967,1.363-26.025,4.381-45.2,1.118a337.3,337.3,0,0,0-37.747-4.072,20.185,20.185,0,0,0-3.881,40.166s27.083,1.651,42.7,7.243,47.237,7.146,49.231,7.279a26.352,26.352,0,0,0,3.518-52.586Z"
                        transform="translate(-438.081 -477.291)"
                        fill="#fff"
                    />
                </clipPath>
            </defs>
            <g id="sad" transform="translate(15313.438 4994.868)">
                <g
                    id="Group_2290"
                    data-name="Group 2290"
                    transform="translate(-15286.622 -4874.483)"
                >
                    <g
                        id="Group_2270"
                        data-name="Group 2270"
                        transform="translate(56.691 263.666)"
                    >
                        <motion.path
                            id="Path_3319"
                            data-name="Path 3319"
                            d="M648.677,868.345A11.734,11.734,0,1,1,637.252,856.3,11.739,11.739,0,0,1,648.677,868.345Z"
                            transform="translate(-625.212 -856.296)"
                            animate={{
                                fill: score >= 1 ? '#f66b12' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 1 ? '#f66b12' : '#D0D0D0',
                            }}
                            onClick={() => setScore(1)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2271"
                        data-name="Group 2271"
                        transform="translate(57.454 234.37)"
                    >
                        <motion.path
                            id="Path_3320"
                            data-name="Path 3320"
                            d="M649.594,833.109a11.734,11.734,0,1,1-11.425-12.046A11.735,11.735,0,0,1,649.594,833.109Z"
                            transform="translate(-626.13 -821.058)"
                            animate={{
                                fill: score >= 2 ? '#f66b12' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 2 ? '#f66b12' : '#D0D0D0',
                            }}
                            onClick={() => setScore(2)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2272"
                        data-name="Group 2272"
                        transform="translate(58.216 205.074)"
                    >
                        <motion.path
                            id="Path_3321"
                            data-name="Path 3321"
                            d="M650.512,797.873a11.735,11.735,0,1,1-11.425-12.05A11.732,11.732,0,0,1,650.512,797.873Z"
                            transform="translate(-627.047 -785.819)"
                            animate={{
                                fill: score >= 3 ? '#f66b12' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 3 ? '#f66b12' : '#D0D0D0',
                            }}
                            onClick={() => setScore(3)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2273"
                        data-name="Group 2273"
                        transform="translate(58.98 175.777)"
                    >
                        <motion.path
                            id="Path_3322"
                            data-name="Path 3322"
                            d="M651.43,762.637A11.735,11.735,0,1,1,640,750.584,11.728,11.728,0,0,1,651.43,762.637Z"
                            transform="translate(-627.965 -750.58)"
                            animate={{
                                fill: score >= 4 ? '#FCB922' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 4 ? '#FCB922' : '#D0D0D0',
                            }}
                            onClick={() => setScore(4)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2274"
                        data-name="Group 2274"
                        transform="translate(59.743 146.481)"
                    >
                        <motion.path
                            id="Path_3323"
                            data-name="Path 3323"
                            d="M652.347,727.4a11.734,11.734,0,1,1-11.424-12.056A11.724,11.724,0,0,1,652.347,727.4Z"
                            transform="translate(-628.883 -715.341)"
                            animate={{
                                fill: score >= 5 ? '#FCB922' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 5 ? '#FCB922' : '#D0D0D0',
                            }}
                            onClick={() => setScore(5)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2275"
                        data-name="Group 2275"
                        transform="translate(60.506 117.185)"
                    >
                        <motion.path
                            id="Path_3324"
                            data-name="Path 3324"
                            d="M653.265,692.166a11.734,11.734,0,1,1-11.425-12.059A11.722,11.722,0,0,1,653.265,692.166Z"
                            transform="translate(-629.801 -680.102)"
                            animate={{
                                fill: score >= 6 ? '#FCB922' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 6 ? '#FCB922' : '#D0D0D0',
                            }}
                            onClick={() => setScore(6)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2276"
                        data-name="Group 2276"
                        transform="translate(61.269 87.889)"
                    >
                        <motion.path
                            id="Path_3325"
                            data-name="Path 3325"
                            d="M654.183,656.93a11.734,11.734,0,1,1-11.425-12.061A11.719,11.719,0,0,1,654.183,656.93Z"
                            transform="translate(-630.719 -644.864)"
                            animate={{
                                fill: score >= 7 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 7 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(7)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2277"
                        data-name="Group 2277"
                        transform="translate(62.032 58.592)"
                    >
                        <motion.path
                            id="Path_3326"
                            data-name="Path 3326"
                            d="M655.1,621.695a11.735,11.735,0,1,1-11.424-12.065A11.713,11.713,0,0,1,655.1,621.695Z"
                            transform="translate(-631.636 -609.625)"
                            animate={{
                                fill: score >= 8 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 8 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(8)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2278"
                        data-name="Group 2278"
                        transform="translate(62.795 29.297)"
                    >
                        <motion.path
                            id="Path_3327"
                            data-name="Path 3327"
                            d="M656.018,586.459a11.735,11.735,0,1,1-11.425-12.067A11.711,11.711,0,0,1,656.018,586.459Z"
                            transform="translate(-632.554 -574.387)"
                            animate={{
                                fill: score >= 9 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 9 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(9)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2279"
                        data-name="Group 2279"
                        transform="translate(63.558 0)"
                    >
                        <motion.path
                            id="Path_3328"
                            data-name="Path 3328"
                            d="M656.935,551.223a11.734,11.734,0,1,1-11.424-12.07A11.707,11.707,0,0,1,656.935,551.223Z"
                            transform="translate(-633.472 -539.148)"
                            animate={{
                                fill: score >= 10 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 10 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(10)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2280"
                        data-name="Group 2280"
                        transform="translate(0 0)"
                    >
                        <motion.path
                            id="Path_3329"
                            data-name="Path 3329"
                            d="M557.026,551.223a11.735,11.735,0,1,1,12.036,11.391A11.791,11.791,0,0,1,557.026,551.223Z"
                            transform="translate(-557.022 -539.148)"
                            animate={{
                                fill: score >= 10 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 10 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(10)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2281"
                        data-name="Group 2281"
                        transform="translate(0.763 29.297)"
                    >
                        <motion.path
                            id="Path_3330"
                            data-name="Path 3330"
                            d="M557.944,586.458a11.735,11.735,0,1,1,12.035,11.394A11.786,11.786,0,0,1,557.944,586.458Z"
                            transform="translate(-557.94 -574.387)"
                            animate={{
                                fill: score >= 9 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 9 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(9)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2282"
                        data-name="Group 2282"
                        transform="translate(1.526 58.592)"
                    >
                        <motion.path
                            id="Path_3331"
                            data-name="Path 3331"
                            d="M558.862,621.695a11.735,11.735,0,1,1,12.035,11.4A11.783,11.783,0,0,1,558.862,621.695Z"
                            transform="translate(-558.858 -609.625)"
                            animate={{
                                fill: score >= 8 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 8 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(8)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2283"
                        data-name="Group 2283"
                        transform="translate(2.289 87.889)"
                    >
                        <motion.path
                            id="Path_3332"
                            data-name="Path 3332"
                            d="M559.779,656.93a11.734,11.734,0,1,1,12.036,11.4A11.779,11.779,0,0,1,559.779,656.93Z"
                            transform="translate(-559.775 -644.864)"
                            animate={{
                                fill: score >= 7 ? '#42C6B9' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 7 ? '#42C6B9' : '#D0D0D0',
                            }}
                            onClick={() => setScore(7)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2284"
                        data-name="Group 2284"
                        transform="translate(3.052 117.185)"
                    >
                        <motion.path
                            id="Path_3333"
                            data-name="Path 3333"
                            d="M560.7,692.166a11.734,11.734,0,1,1,12.035,11.4A11.776,11.776,0,0,1,560.7,692.166Z"
                            transform="translate(-560.693 -680.102)"
                            animate={{
                                fill: score >= 6 ? '#FCB922' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 6 ? '#FCB922' : '#D0D0D0',
                            }}
                            onClick={() => setScore(6)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2285"
                        data-name="Group 2285"
                        transform="translate(3.814 146.481)"
                    >
                        <motion.path
                            id="Path_3334"
                            data-name="Path 3334"
                            d="M561.614,727.4a11.735,11.735,0,1,1,12.036,11.406A11.773,11.773,0,0,1,561.614,727.4Z"
                            transform="translate(-561.61 -715.341)"
                            animate={{
                                fill: score >= 5 ? '#FCB922' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 5 ? '#FCB922' : '#D0D0D0',
                            }}
                            onClick={() => setScore(5)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2286"
                        data-name="Group 2286"
                        transform="translate(4.577 175.777)"
                    >
                        <motion.path
                            id="Path_3335"
                            data-name="Path 3335"
                            d="M562.532,762.637a11.735,11.735,0,1,1,12.036,11.408A11.77,11.77,0,0,1,562.532,762.637Z"
                            transform="translate(-562.528 -750.58)"
                            animate={{
                                fill: score >= 4 ? '#FCB922' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 4 ? '#FCB922' : '#D0D0D0',
                            }}
                            onClick={() => setScore(4)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2287"
                        data-name="Group 2287"
                        transform="translate(5.341 205.074)"
                    >
                        <motion.path
                            id="Path_3336"
                            data-name="Path 3336"
                            d="M563.45,797.873a11.734,11.734,0,1,1,12.036,11.411A11.766,11.766,0,0,1,563.45,797.873Z"
                            transform="translate(-563.446 -785.819)"
                            animate={{
                                fill: score >= 3 ? '#f66b12' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 3 ? '#f66b12' : '#D0D0D0',
                            }}
                            onClick={() => setScore(3)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2288"
                        data-name="Group 2288"
                        transform="translate(6.103 234.37)"
                    >
                        <motion.path
                            id="Path_3337"
                            data-name="Path 3337"
                            d="M564.367,833.108A11.734,11.734,0,1,1,576.4,844.522,11.763,11.763,0,0,1,564.367,833.108Z"
                            transform="translate(-564.363 -821.057)"
                            animate={{
                                fill: score >= 2 ? '#f66b12' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 2 ? '#f66b12' : '#D0D0D0',
                            }}
                            onClick={() => setScore(2)}
                            styleName="clickable"
                        />
                    </g>
                    <g
                        id="Group_2289"
                        data-name="Group 2289"
                        transform="translate(6.866 263.666)"
                    >
                        <motion.path
                            id="Path_3338"
                            data-name="Path 3338"
                            d="M565.285,868.345a11.734,11.734,0,1,1,12.036,11.416A11.759,11.759,0,0,1,565.285,868.345Z"
                            transform="translate(-565.281 -856.296)"
                            animate={{
                                fill: score >= 1 ? '#f66b12' : '#D0D0D0',
                            }}
                            initial={{
                                fill: score >= 1 ? '#f66b12' : '#D0D0D0',
                            }}
                            onClick={() => setScore(1)}
                            styleName="clickable"
                        />
                    </g>
                </g>
                <g
                    id="Group_2291"
                    data-name="Group 2291"
                    transform="translate(-15275.929 -4947.116)"
                >
                    <path
                        id="Path_3339"
                        data-name="Path 3339"
                        d="M602.8,451.782h0c-19.057,0-33.757,15.182-32.876,42.262l10.242,393.3H625.43l10.242-393.3C636.554,466.964,621.855,451.782,602.8,451.782Z"
                        transform="translate(-569.885 -451.782)"
                        fill="#2f2f2f"
                    />
                    <path
                        id="Path_3340"
                        data-name="Path 3340"
                        d="M605.675,475.638h0c-9.849,0-17.629,7.835-17.382,21.986L593.5,875.118h24.49l5.077-377.495C623.309,483.473,615.524,475.638,605.675,475.638Z"
                        transform="translate(-572.988 -455.805)"
                        fill="#3a3a3a"
                    />
                </g>
                <g
                    id="Group_2295"
                    data-name="Group 2295"
                    transform="translate(-15313.438 -4539.723)"
                >
                    <ellipse
                        id="Ellipse_234"
                        data-name="Ellipse 234"
                        cx="70.202"
                        cy="22.32"
                        rx="70.202"
                        ry="22.32"
                        transform="translate(0 53.813)"
                        opacity="0.1"
                    />
                    <path
                        id="Path_3350"
                        data-name="Path 3350"
                        d="M657.877,1018.516,647.4,980.9c0-16.922-101.078-16.922-101.078,0l-9.425,36.955C536.736,1047.39,657.716,1048.052,657.877,1018.516Z"
                        transform="translate(-526.812 -946.262)"
                        fill="#2f2f2f"
                    />
                    <path
                        id="Path_3351"
                        data-name="Path 3351"
                        d="M556.955,1037.092l-.645-12.689-1.913,11.831Q555.635,1036.679,556.955,1037.092Z"
                        transform="translate(-529.763 -955.738)"
                        fill="#3a3a3a"
                    />
                    <path
                        id="Path_3352"
                        data-name="Path 3352"
                        d="M545.958,1029.506l10.843-26.222-5.026,28.916a23.952,23.952,0,0,1-5.816-2.694"
                        transform="translate(-528.34 -952.177)"
                        fill="#3a3a3a"
                    />
                    <ellipse
                        id="Ellipse_235"
                        data-name="Ellipse 235"
                        cx="50.222"
                        cy="16.173"
                        rx="50.222"
                        ry="16.173"
                        transform="translate(19.981 18.761)"
                        fill="#4d4d4d"
                    />
                    <ellipse
                        id="Ellipse_236"
                        data-name="Ellipse 236"
                        cx="45.316"
                        cy="15.31"
                        rx="45.316"
                        ry="15.31"
                        transform="translate(27.192 17.746)"
                        opacity="0.2"
                    />
                    <motion.g
                        id="Button"
                        whileTap={{ scale: 0.975, y: 2 }}
                        initial={{ scale: 1, y: 0 }}
                        style={{ cursor: isViewing ? 'default' : 'pointer' }}
                        onClick={handleButtonPress}
                    >
                        <path
                            id="Path_3348"
                            data-name="Path 3348"
                            d="M1051.414,946.693a111.352,111.352,0,0,0-37.95,0l-22.891,5.529c-1.8,0-4,3.873-4,5.468v13.718c0,10.07,20.535,18.234,45.866,18.234s45.866-8.164,45.866-18.234V957.69c0-1.595-2.195-5.468-4-5.468Z"
                            transform="translate(-962.093 -942.359)"
                            fill="#4261e8"
                        />
                        <path
                            id="Path_3349"
                            data-name="Path 3349"
                            d="M1003.94,990.41l1.317-12.381-3.924,11.351Q1002.585,989.915,1003.94,990.41Z"
                            transform="translate(-964.582 -947.917)"
                            fill="#fff"
                            opacity="0.31"
                        />
                        <ellipse
                            id="Ellipse_233"
                            data-name="Ellipse 233"
                            cx="44.416"
                            cy="12.497"
                            rx="44.416"
                            ry="12.497"
                            transform="translate(25.913)"
                            fill="#6581ea"
                        />
                    </motion.g>
                </g>
                <g
                    id="Group_2305"
                    data-name="Group 2305"
                    transform="translate(-15285.967 -4984.868)"
                >
                    <g
                        id="Group_2296"
                        data-name="Group 2296"
                        transform="translate(0)"
                    >
                        <motion.g
                            id="background"
                            animate={{
                                fill: getColor(),
                            }}
                            initial={{ fill: getColor() }}
                            stroke="#1a1a1a"
                            strokeMiterlimit="10"
                            strokeWidth="10"
                        >
                            <circle
                                cx="44.334"
                                cy="44.334"
                                r="44.334"
                                stroke="none"
                            />
                            <circle
                                cx="44.334"
                                cy="44.334"
                                r="49.334"
                                fill="none"
                            />
                        </motion.g>
                    </g>
                    <g
                        id="Group_2304"
                        data-name="Group 2304"
                        transform="translate(0 0)"
                    >
                        <g
                            id="Group_2303"
                            data-name="Group 2303"
                            clipPath="url(#clip-path)"
                        >
                            {emotion === 'sad' ? (
                                <SpiekSad />
                            ) : emotion === 'oke' ? (
                                <SpiekOke />
                            ) : (
                                <SpiekHappy />
                            )}
                        </g>
                    </g>
                </g>
                <circle
                    id="Ellipse_258"
                    data-name="Ellipse 258"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4603.572)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(1)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_259"
                    data-name="Ellipse 259"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4632.869)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(2)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_260"
                    data-name="Ellipse 260"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4662.165)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(3)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_261"
                    data-name="Ellipse 261"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4691.461)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(4)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_262"
                    data-name="Ellipse 262"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4720.757)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(5)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_263"
                    data-name="Ellipse 263"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4750.054)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(6)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_264"
                    data-name="Ellipse 264"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4779.35)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(7)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_265"
                    data-name="Ellipse 265"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4808.646)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(8)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_266"
                    data-name="Ellipse 266"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4837.942)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(9)}
                    styleName="clickable"
                />
                <circle
                    id="Ellipse_267"
                    data-name="Ellipse 267"
                    cx="4.49"
                    cy="4.49"
                    r="4.49"
                    transform="translate(-15247.727 -4867.238)"
                    fill="#fff"
                    strokeWidth="18"
                    strokeOpacity="0"
                    stroke="black"
                    opacity="0.1"
                    onClick={() => setScore(10)}
                    styleName="clickable"
                />
                <motion.g
                    animate={{
                        y: -score * 29.25 + 29.25,
                        scale: 1 + score * 0.03,
                        opacity: score < 1 ? 0 : 1,
                    }}
                    initial={{
                        y: -score * 29.25 + 29.25,
                        scale: 1 + score * 0.03,
                        opacity: score < 1 ? 0 : 1,
                    }}
                >
                    <motion.circle
                        id="current"
                        cx="14.032"
                        cy="14.032"
                        r="14.032"
                        transform="translate(-15257.269 -4613.114)"
                        animate={{
                            fill: getColor(),
                        }}
                        initial={{ fill: getColor() }}
                    />
                </motion.g>
            </g>
        </svg>
    );
};

export default function Thermometer({
    text,
    type,
}: {
    text: string;
    type: 'enjoy' | 'skill' | 'motivation';
}) {
    const { play } = useAudio({ text });

    const { setResults, sequence, results } = useContext(
        ThermometerSequenceContext
    );

    const score =
        results[`${sequence === 'lezen' ? 'reading' : 'spelling'}_${type}`];

    const setScore = (number: number) =>
        setResults((prev) => ({
            ...prev,
            [`${
                sequence === 'lezen' ? 'reading' : 'spelling'
            }_${type}`]: number,
        }));

    return (
        <div styleName="wrapper">
            <Svg score={score} setScore={setScore} />
            <motion.button
                type="button"
                initial={{ y: -10 }}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => play()}
            >
                <FontAwesomeIcon icon={faVolumeUp} />
                {text}
            </motion.button>
        </div>
    );
}
